
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-flaky",
  "use": "icon-material-flaky-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-flaky\"><path d=\"M480-74.02q-86.2 0-160.39-31t-128.89-85.7-85.7-128.89-31-160.39q0-85.43 31-159.51 31-74.07 85.7-128.89t128.89-86.32T480-886.22q85.43 0 159.51 31.5 74.07 31.5 128.89 86.32t86.32 128.89q31.5 74.08 31.5 159.51 0 86.2-31.5 160.39T768.4-190.72t-128.89 85.7q-74.08 31-159.51 31M294-516.09l56-57 56 57L443.91-554l-57-56 57-56L406-703.91l-56 57-56-57L256.09-666l57 56-57 56zm185.96 373.94q144.08 0 240.99-96.78 96.9-96.79 96.9-241.07 0-71.76-25.75-133.27-25.74-61.52-71.53-107.3L239.43-239.43q45.86 45.79 107.36 71.53 61.5 25.75 133.17 25.75M562-261.09 471.09-352 508-389.91l54 54 100-99L698.91-398z\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-flaky"/>
                </svg>
            );
        };

        Icon.id = "icon-material-flaky";

        export default Icon;
    